export default __webpack_public_path__ + "static/media/ai-flag.c79945ff.svg";